cb.define([], function() {
  var AA_aa_department_VM_extend = {

    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      var self = this;
      self.setDisaTrue(viewmodel);
      viewmodel.on("afterAdd", function() {
        self.setDisaTrue(viewmodel);
      });
      viewmodel.getTreeModel().setState('maxLevel', false);
      viewmodel.on("afterLoadData", function(data) {
        viewmodel.get('parent_name').setState('maxLevel', false);
        if (viewmodel.getParams().mode === 'add') {
          self.setDisaTrue(viewmodel);
        }
      });
      viewmodel.getTreeModel().setState('maxLevel', 100)
      viewmodel.on("afterDelete", function() {
        self.setDisaTrue(viewmodel);
        // viewmodel.biz.do('add', viewmodel);
      });
      viewmodel.on('afterAbandon', function(data) {
        var res = data.res;
        if (res != undefined) {
          var id = res.id;
          if (id != undefined) {
            self.setDisaFalse(viewmodel);
          } else {
            self.setDisaTrue(viewmodel);
          }
        } else {
          self.setDisaTrue(viewmodel);
        }
      });
      viewmodel.on('afterSave', function(data) {
        if (data.res != undefined) {
          var treeModel = viewmodel.getTreeModel();
          var selectedNodes = treeModel.getSelectedNodes();
          if (!selectedNodes.length) return;
          var stopstatus = self.getTrue(viewmodel.get("stopstatus").getData());
          if (stopstatus) {
            treeModel.updateNodeRecursive(selectedNodes[0], "stopstatus", stopstatus);
            self.setAddTrue(viewmodel);
          } else {
            self.setAddFalse(viewmodel);
          }
        }
      });
      viewmodel.on('beforeSave', function(args) {
        var data = JSON.parse(args.data.data);
        if (data == null)
          return false;
        var stopstatus = self.getTrue(data.stopstatus);
        var isEnd = data.isEnd;
        if (stopstatus && !isEnd && isEnd != undefined) {
          var returnPromise = new cb.promise();
          cb.utils.confirm('您确定停用当前部门和所有下级部门？', function() {
            return returnPromise.resolve();
          }, function() {
            returnPromise.reject();
          });
          return returnPromise;
        } else {
          return true;
        }
      });

      //选择上级部门之前，判断，选定的部门是否已经是当前部门的下级部门
      viewmodel.get("parent_name").on("beforeValueChange", function(data) {
        if (!data.value) return;
        var selectedDepts = viewmodel.getTreeModel().getSelectedNodes();
        if (!selectedDepts.length) return;
        return self.canChoose(data.value, selectedDepts[0]);
      });
      viewmodel.get("aa_department-03848").on("afterSelect", function(data) {
        //未选中任何树节点
        if (data.length == 0) {
          self.setDisaTrue(viewmodel);
          // viewmodel.biz.do('add', viewmodel);
        } else {
          if (!data[0].stopstatus)
            self.setAddFalse(viewmodel);
          else
            self.setAddTrue(viewmodel);
        }
        //父节点，不允许删除
        if (data.length == 0 || data[0].level == 0)
          self.setDeleteTrue(viewmodel);
        else
          self.setDeleteFalse(viewmodel);
      });
    },
    canChoose: function(value, dept) {
      if (value.id === dept.id) {
        cb.utils.alert('只能选择上级部门！', 'warning');
        return false;
      }
      if (dept.children) {
        for (var i = 0, len = dept.children.length; i < len; i++) {
          if (this.canChoose(value, dept.children[i])) continue;
          return false;
        }
      }
      return true;
    },
    getTrue: function(value) {
      if (value == "false" || !value || value == 0)
        return false;
      return true;
    },
    setAddTrue: function(viewmodel) {
      var btnAdd = viewmodel.get("btnAdd");
      if (btnAdd != undefined)
        viewmodel.get("btnAdd").setDisabled(true);
    },
    setAddFalse: function(viewmodel) {
      var btnAdd = viewmodel.get("btnAdd");
      if (btnAdd != undefined)
        viewmodel.get("btnAdd").setDisabled(false);
    },
    setDeleteTrue: function(viewmodel) {
      var btnDelete = viewmodel.get("btnDelete");
      if (btnDelete != undefined)
        viewmodel.get("btnDelete").setDisabled(true);
    },
    setDeleteFalse: function(viewmodel) {
      var btnDelete = viewmodel.get("btnDelete");
      if (btnDelete != undefined)
        viewmodel.get("btnDelete").setDisabled(false);
    },
    setDisaTrue: function(viewmodel) {
      this.setAddTrue(viewmodel);
      this.setDeleteTrue(viewmodel);
    },
    setDisaFalse: function(viewmodel) {
      this.setAddFalse(viewmodel);
      this.setDeleteFalse(viewmodel);
    }
  }
  try { module.exports = AA_aa_department_VM_extend; } catch (error) {}
  return AA_aa_department_VM_extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_department_VM.Extend.js